import { Box, Theme } from '@mui/material'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ContactHistoryWrapper = styled('div')`
  padding: 16px;
  background-color: #fafafa;
`

export const SectionItemWrapper = styled('div')`
  padding: 8px 0;
  background: #ffffff;
  margin-bottom: 10px;
  border: 1px solid #f6f6f6;
  width: 315px;
`

export const MonthItemContainer = styled('div')<{ $selected?: boolean }>`
  width: 25px;
  height: 26px;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;

  ${({ $selected }) => `
    & p {
      font-weight: ${$selected ? '700 !important' : ''};
    }
  `}
`

export const ContactsListWrapper = styled(Box)`
  width: 100%;
  min-height: 100px;
  max-height: 200px;
  overflow: auto;
  padding: 0 10px;
  gap: 10px;
  display: flex;
  flex-direction: column;

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${colors.white};
    border-radius: 12px;
    background-clip: padding-box;
    width: 10px;
    height: 90px;
    border: 1px solid ${colors.backgroundGrey};
  }

  ::-webkit-scrollbar-track {
    background-color: ${colors.backgroundGrey};
    border-radius: 12px;
  }
`

export const LoadingWrapper = styled(Box)`
  padding: 10px;
  margin-left: 10px;
  width: 280px;
  background: ${colors.white};
  border: 1px solid ${colors.lightGrey};
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 10px;
`

export const DayWrapper = styled('div')<{ $selected?: boolean; $color?: string }>`
  width: 19px;
  height: 19px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  cursor: ${({ $color }) => ($color ? 'pointer' : 'default')};
  color: ${({ $color }) => ($color ? '#fff' : '#1d1d1d')};
  user-select: none;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
    z-index: -1;
    box-shadow: ${({ $color, $selected }) => ($selected ? `0 0 0 2px white , 0 0 0 3px ${$color}` : '')};
  }
  ${({ $color }) => (!$color ? 'pointer-events: none;' : '')}

  ${({ $color, $selected }) =>
    $selected && $color
      ? `
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        top: 26px;
        width: 0;
        height: 0;
        border-left: 9px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid transparent;
        border-bottom: 16px solid ${$color};
        clear: both;
      }
    `
      : ''}
`

export const MeetingDotsContainer = styled('div')`
  display: flex;
  align-self: center;
  height: 6px;
  width: 24px;
  transition: 1s;
  overflow: hidden;
  position: relative;
  align-items: center;
`

export const MeetingDot = styled('div')<{ $color: string }>`
  flex: 0 0 auto;
  width: 2px;
  height: 6px;
  margin-right: 1px;
  ${({ $color }) => `
    background-color: ${$color};
  `}
`

export const TabsCarouselWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const IconButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: ${colors.commonLightGrey};
  }
`

export const RightIconTriangle = styled('div')`
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  margin-left: 3px;
  cursor: pointer;
  border-left: 18px solid ${colors.primary};

  &:active {
    border-left: 18px solid ${colors.primaryDark};
  }
`

export const LeftIconTriangle = styled(RightIconTriangle)`
  transform: rotate(180deg);
  margin-right: 3px;
  margin-left: 0;
`

export const LeftButton = styled('div')`
  display: flex;
  align-items: center;
  height: 27px;
  border-right: 1px solid #cecece;
  margin-right: 5px;
`

export const RightButton = styled(LeftButton)`
  border-right: none;
  border-left: 1px solid #cecece;
  margin-right: 0;
  margin-left: 5px;
`

export const SliderContainer = styled('div')`
  position: relative;
  padding: 0 4px;
  margin: 4px 6px 0 6px;
`

interface YearDropdownProps {
  $isClickable?: boolean
}

export const YearDropdown = styled('div')<YearDropdownProps>`
  display: inline-flex;
  align-items: center;
  ${({ $isClickable }: { $isClickable?: boolean }) => ($isClickable ? 'cursor: pointer;' : '')}

  & > svg {
    fill: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
  }
`

export const YearDropdownItemLabel = styled(Typography)`
  color: ${({ $isSelected, $isDisabled, theme }: { $isSelected?: boolean; $isDisabled?: boolean; theme: Theme }) => {
    if ($isSelected) {
      return theme.palette.primary.main
    }

    if ($isDisabled) {
      return colors.lightGrey
    }

    return colors.black
  }};
  font-weight: 500;
`
